import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { GlobalNamespace as _GlobalNS, environment } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import { catchError } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var TaskService = /** @class */ (function () {
    function TaskService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.taskStatus = { OverDue: 1, Warning: 2, OnTime: 3, Complete: 4, NC: 5, Paused: 6, UA: 7, Processing: 120 };
    }
    TaskService.prototype.getTasksByPropertyId = function () {
        var api = _GlobalNS.api.task.list;
        var propertyid = this._global.find(_GlobalNS.paths.PropertyId);
        var url = (environment.production) ? api + "&PropertyId=" + propertyid : api + "?PropertyId=1";
        return this._http.get(url, {});
    };
    TaskService.prototype.getCompletedTask = function () {
        var api = _GlobalNS.api.task.completedTask;
        return this._http.get(api);
    };
    TaskService.prototype.getCompletedTaskMenuItems = function (propertyId) {
        var _this = this;
        var items = [{ id: '1' }, { id: '2' }];
        items.map(function (i) {
            i.label = (i.id === '1') ? 'Open in New Window' : 'Open Property';
            i.url = _this.getPropertyViewUri(propertyId);
            i.target = (i.id === '1') ? '_blank' : '_self';
        });
        return items;
    };
    TaskService.prototype.getPropertyViewUri = function (propertyId) {
        var api = _GlobalNS.routes.property.viewTasks;
        var buildUri = api + "&property_id=" + propertyId;
        return buildUri;
    };
    TaskService.prototype.getTaskViewUri = function (eventlocation, property_id, eventTrackingID, event_tracking_parent) {
        var buildUri = eventlocation + "&property_id=" + property_id + "&eventTrackingID=" + eventTrackingID;
        buildUri = (event_tracking_parent !== null) ? buildUri + "&event_tracking_parent=" + event_tracking_parent : buildUri;
        return _GlobalNS.api.baseEvent + buildUri;
    };
    TaskService.prototype.getTaskCounter = function () {
        var api = _GlobalNS.api.task.counter;
        var propertyId = this._global.find(_GlobalNS.paths.PropertyId);
        var url = (environment.production) ? api + "&PropertyId=" + propertyId : api + "?PropertyId=1";
        return this._http.get(url);
    };
    /*
    get current person(logged in) details.
    Tasks which logged in user can completed.
    */
    TaskService.prototype.findByPerson = function (searchParams, canComplete) {
        var api = _GlobalNS.api.task.taskToComplete;
        searchParams.CanComplete = canComplete;
        return this._http.get("" + api, { params: searchParams }).pipe(catchError(function (err) {
            return throwError(err);
        }));
    };
    /* return task status class name based task status ID */
    TaskService.prototype.getStatusClass = function (taskStatus) {
        if (taskStatus === this.taskStatus.OverDue) {
            return 'overdue';
        }
        else if (taskStatus === this.taskStatus.Warning) {
            return 'warning';
        }
        else if (taskStatus === this.taskStatus.OnTime) {
            return 'ontime';
        }
        else if (taskStatus === this.taskStatus.Paused) {
            return 'paused';
        }
        else if (taskStatus === this.taskStatus.Processing) {
            return 'processing';
        }
        else {
            return 'complete';
        }
    };
    TaskService.prototype.getCanCompleteTasksCounter = function () {
        var api = _GlobalNS.api.task.assignedTasks;
        return this._http.get("" + api);
    };
    TaskService.ngInjectableDef = i0.defineInjectable({ factory: function TaskService_Factory() { return new TaskService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: TaskService, providedIn: "root" });
    return TaskService;
}());
export { TaskService };
